module.exports = __webpack_public_path__ + "img/soccer.a2353cfd.svg";